"use client";

import { twMerge } from "tailwind-merge";
import CheckMarks from "@/components/common/CheckMarks";
import BusinesCard from "@/components/common/BusinesCard";
import HeroSection from "@/components/common/HeroSection";
import MiniCard from "@/components/common/MiniCard";

import { CloudData, points, ImageCardData } from "@/constants/CloudData";
import ImageCard from "@/components/common/ImageCard";
import ReviewSlider from "@/components/Reviews";
import SectionHeader from "@/components/common/SectionHeader";
import GradientBottom from "@/components/common/GradientBottom";
import { useIsDark } from "@/context/ThemeContext";
import StatsCardsContainer from "@/components/StatCard";

const cards = [
  { icon: "/assets/cloud/minibug.svg", title: "ERP SYSTEMS" },
  { icon: "/assets/cloud/minibug.svg", title: "HEALTHCARE PLATFORMS" },
  { icon: "/assets/cloud/minibug.svg", title: "E-COMMERCE SOLUTIONS" },
  { icon: "/assets/cloud/minibug.svg", title: "SAAS INFRASTRUCTURE" },
];

export default function Cloud() {
  const isdark = useIsDark();

  return (
    <>
      <div className="relative flex flex-col justify-center items-center mt-6 mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150] z-10">
        <HeroSection
          heading="Cloud & DevOps"
          paragraph="Scalable, secure, and cost-effective cloud solutions to accelerate your business transformation."
          headingStyles="text-[45px] mobile:text-[75px] sm:text-[90px] md:text-[115px] tablet:text-[135px] lg:text-[150px] xl:text-[165px] laptop:text-[175px] 3xl:text-[190px] 4xl:text-[220px] leading-[100%] text-center"
          paragraphStyles="font-alexandria font-medium"
        />

        <div className="flex items-center justify-center ">
          <button
            className="mt-[32px] w-[170px] h-[38px] mobile:w-[200px] mobile:h-[40px] md:w-[244px] md:h-[50px] lg:w-[300px] lg:h-[60px] laptop:w-[350px] laptop:h-[68px] 3xl:w-[400px] 3xl:h-[75px] rounded-[7px] bg-[#DF27DF] dark:bg-[#DF27DF40]
                     flex items-center justify-center gap-[4px] text-white dark:text-[#DF27DF] dark:border dark:border-[#DF27DF] font-semibold text-[12px] mobile:text-[13px] md:text-[15px] lg:text-[20px] laptop:text-[24px] 3xl:text-[27px] leading-[100%] tracking-[0px] 
             font-['Albert_Sans']
                        "
          >
            Explore Our Cloud Solutions
          </button>
        </div>

        <section className="flex flex-col items-center xl:mt-[30px]">
          <SectionHeader
            title={" Our Cloud Service Expertise"}
            description={
              "Comprehensive cloud solutions tailored to your business needs"
            }
            wrapperClassName="mt-25 mb-[50px]"
            titleClassName="xl:text-[35px]"
            descriptionClassName="mt-[50px]"
          />
          <div className="grid grid-cols-1 mobile:grid-cols-2 md:grid-cols-3 gap-[20px] mobile:gap-[10px] md:gap-[18px] lg:gap-[18px] xl:gap-[38px] laptop:gap-x-[22px] mt-[10px] px-4 sm:px-6 md:px-6 mobile:gap-y-[15px] sm:gap-x-[18px]">
            {CloudData.map((item, index) => (
              <MiniCard
                key={index}
                icon={item.icon}
                iconStyles={item.iconStyles}
                heading={item.heading}
                paragraph={item.paragraph}
                cardStyles="w-full max-w-[398px] h-auto max-h-[436px] xl:h-[436px] mx-auto" //w398*h436
                headingStyles="laptop:text-[22px]"
                paragraphStyles="laptop:text-[20px]"
              />
            ))}
          </div>
        </section>
      </div>

      <section
        className={twMerge(
          "flex flex-col items-center w-full py-[25px] xl:py-[50px] px-5 md:px-[40px] xl:px-[100px] mt-10 3xl:mt-15",
          isdark ? "bg-[#2D2D2D]/50" : "bg-[#F2E4FE]/50"
        )}
      >
        <div className="w-full max-w-[2000px]">
          <SectionHeader
            title={"Why Choose Cloud Solutions?"}
            description={"Transform your business with proven cloud advantages"}
            wrapperClassName="mt-0 mb-0 px-0"
            descriptionClassName="xl:mt-[50px]"
          />
          <div className="flex flex-col md:flex-row justify-between items-center mt-[25px] xl:mt-[50px]">
            <CheckMarks points={points} />
            <StatsCardsContainer gridStyles="p-2" cardStyles="md:w-[150px]" />
          </div>
        </div>
      </section>

      <section>
        <SectionHeader
          title={"Designed for All Business Types"}
          description={" Tailored solutions across industries"}
          wrapperClassName="mt-25 mb-[50px]"
          titleClassName="xl:text-[35px]"
          descriptionClassName="mt-[50px]"
        />
      </section>

      <div className="grid grid-cols-1 mobile:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 ml-9 mr-9 items-center gap-4 md:gap-6 md:gap-10 mt-10 tablet:px-8 xl:px-20">
        {cards.map((card, index) => (
          <BusinesCard key={index} icon={card.icon} title={card.title} />
        ))}
      </div>

      {/* <SectionHeader
        title={"Recent Cloud Deployments"}
        description={
          "Successful cloud transformations across various industries"
        }
        wrapperClassName="mt-[50px] mb-0"
      /> */}
      {/* <div className="w-full px-5 md:px-10 xl:px-[100px]"> */}
      {/* Card slider for small screens */}
      {/* <div className="flex w-full mobile:hidden gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar">
          {ImageCardData.map((item, index) => (
            <div
              key={index}
              className="shrink-0 basis-[80%] small:basis-[65%]"
            >
              <ImageCard
                image={isdark ? item.darkImg : item.lightImg}
                topic={item.topic}
                text={item.text}
                tag={item.tag}
                sizes="(max-width: 480px) 80vw, 65vw"
                hoverOverlayColor="rgba(26, 26, 26, 0.2)"
              />
            </div>
          ))}
        </div> */}

      {/* <div className="hidden mobile:grid mobile:grid-cols-2 tablet:grid-cols-3 w-full max-w-[2000px] gap-x-4 sm:gap-x-6 2xl:gap-x-8 3xl:gap-x-10 4xl:gap-x-12 gap-y-2 mt-[30px] mx-auto">
          {ImageCardData.map((item, index) => (
            <ImageCard
              key={index}
              image={isdark ? item.darkImg : item.lightImg}
              topic={item.topic}
              text={item.text}
              tag={item.tag}
              sizes="(max-width: 640px) 50vw, (max-width: 768px) 33vw, 30vw"
              hoverOverlayColor="rgba(26, 26, 26, 0.2)"
            />
          ))}
        </div>
      </div> */}

      <section>
        <SectionHeader
          title={"What Our Clients Say"}
          description={
            "Our work speaks for itself.  Hear from businesses that have partnered  with us to build high-quality digital solutions, optimize their operations, and achieve measurable success."
          }
          wrapperClassName="mt-25 mb-[50px]"
          titleClassName="xl:text-[35px]"
          descriptionClassName="mt-[50px]"
        />
      </section>

      <ReviewSlider />

      <section className="w-full mt-25">
        <GradientBottom
          heading="Need a Custom Software Solution?"
          subHeading="Let's build something great together."
          buttonText="Get in Touch"
          buttonHref="/contact"
        />
      </section>
    </>
  );
}
